import React from 'react';
import { formatPrice } from 'utils/helpers';

const Subtotal = ({ styles, priceInfo }) => (
  <div className={styles.subtotal}>
    <h3>SUBTOTAL</h3>

    <div className={styles.row}>
      GigSocial Fee: <span>{priceInfo.checkout_price ? formatPrice(priceInfo.fee) : 'N/A'}</span>
    </div>

    <div className={styles.row}>
      <span className="avenir-heavy">Total to pay:</span>{' '}
      <span className={styles.price}>{priceInfo.checkout_price ? formatPrice(priceInfo.checkout_price) : 'N/A'}</span>
    </div>
  </div>
);

export default Subtotal;
